var _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text10, _text11, _text12, _text13, _text14, _text15, _text16, _text17, _text18, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _path2, _text19, _text20, _path3, _circle13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGaGraph(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: 203.508,
    viewBox: "0 0 333 203.508",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_3094",
    "data-name": "Group 3094",
    transform: "translate(-85 -1897)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_781",
    "data-name": "Group 781",
    transform: "translate(41 1770)"
  }, _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "_50",
    "data-name": 50,
    transform: "translate(80.367 248.769)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -11.23,
    y: 0
  }, "50"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    id: "_100",
    "data-name": 100,
    transform: "translate(80.367 207.201)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -16.846,
    y: 0
  }, "100"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    id: "_150",
    "data-name": 150,
    transform: "translate(79.895 166.636)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -16.846,
    y: 0
  }, "150"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    id: "_0",
    "data-name": 0,
    transform: "translate(80.367 290.337)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -5.615,
    y: 0
  }, "0"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    id: "May",
    transform: "translate(191.267 309.537)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.451,
    y: 0
  }, "May"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    id: "Mar",
    transform: "translate(140.854 308.537)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.777,
    y: 0
  }, "Mar"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    id: "Jan",
    transform: "translate(93.158 309.537)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.237,
    y: 0
  }, "Jan"))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    id: "Month",
    transform: "translate(230.28 327.508)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -14.363,
    y: 0
  }, "Month"))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    id: "Users",
    transform: "translate(54 229.173) rotate(-90)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.739,
    y: 0
  }, "Users"))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    id: "Sep",
    transform: "translate(292.303 309.537)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.42,
    y: 0
  }, "Sep"))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    id: "Jul",
    transform: "translate(242.009 309.537)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6.729,
    y: 0
  }, "Jul"))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    id: "Nov",
    transform: "translate(341.541 309.537)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.801,
    y: 0
  }, "Nov"))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    id: "Jun",
    transform: "translate(216.677 308.537)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.274,
    y: 0
  }, "Jun"))), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    id: "Apr",
    transform: "translate(166.099 309.537)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -7.759,
    y: 0
  }, "Apr"))), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    id: "Feb",
    transform: "translate(115.612 309.537)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.218,
    y: 0
  }, "Feb"))), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    id: "Oct",
    transform: "translate(317.544 309.537)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -7.688,
    y: 0
  }, "Oct"))), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    id: "Aug",
    transform: "translate(267.065 308.537)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.796,
    y: 0
  }, "Aug"))), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    id: "Dec",
    transform: "translate(368 309.537)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.545,
    y: 0
  }, "Dec"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    y1: 134.491,
    transform: "translate(92.678 163.636)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    y1: 134.491,
    transform: "translate(141.261 163.636)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    y1: 134.491,
    transform: "translate(191.807 163.636)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    y1: 134.491,
    transform: "translate(242.352 163.636)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    y1: 134.491,
    transform: "translate(292.899 163.636)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    y1: 134.491,
    transform: "translate(342.019 163.636)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    y1: 134.491,
    transform: "translate(115.988 163.636)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    y1: 134.491,
    transform: "translate(166.534 163.636)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    id: "Line_10",
    "data-name": "Line 10",
    y1: 134.491,
    transform: "translate(217.08 163.636)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    id: "Line_11",
    "data-name": "Line 11",
    y1: 134.491,
    transform: "translate(267.625 163.636)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    id: "Line_12",
    "data-name": "Line 12",
    y1: 134.491,
    transform: "translate(315.661 163.636)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    id: "Line_13",
    "data-name": "Line 13",
    y1: 134.491,
    transform: "translate(368.377 163.636)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    id: "Line_14",
    "data-name": "Line 14",
    x2: 283.459,
    transform: "translate(84.541 247.06)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    id: "Line_15",
    "data-name": "Line 15",
    x2: 283.459,
    transform: "translate(84.541 205.48)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    id: "Line_16",
    "data-name": "Line 16",
    x2: 283.459,
    transform: "translate(84.541 163.9)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    id: "Line_17",
    "data-name": "Line 17",
    x2: 283.459,
    transform: "translate(84.541 288.641)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(87.565 203.701)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 4.619,
    cy: 4.619,
    r: 4.619,
    transform: "translate(0 24.833)",
    fill: "#e0e1e3",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 4.619,
    cy: 4.619,
    r: 4.619,
    transform: "translate(23.408 11.275)",
    fill: "#e0e1e3",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 4.619,
    cy: 4.619,
    r: 4.619,
    transform: "translate(49.227 18.116)",
    fill: "#e6e7e8",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 4.619,
    cy: 4.619,
    r: 4.619,
    transform: "translate(74.34 -3.131)",
    fill: "#e0e1e3",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 4.619,
    cy: 4.619,
    r: 4.619,
    transform: "translate(100.454 13.753)",
    fill: "#e0e1e3",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 4.619,
    cy: 4.619,
    r: 4.619,
    transform: "translate(124.567 27.674)",
    fill: "#e0e1e3",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 4.619,
    cy: 4.619,
    r: 4.619,
    transform: "translate(149.681 -0.123)",
    fill: "#e0e1e3",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 4.619,
    cy: 4.619,
    r: 4.619,
    transform: "translate(175.794)",
    fill: "#e0e1e3",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 4.619,
    cy: 4.619,
    r: 4.619,
    transform: "translate(200.908 18.355)",
    fill: "#e0e1e3",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 4.619,
    cy: 4.619,
    r: 4.619,
    transform: "translate(223.021 -12.29)",
    fill: "#e0e1e3",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 4.619,
    cy: 4.619,
    r: 4.619,
    transform: "translate(249.84 -9.522)",
    fill: "#e6e7e8",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 4.619,
    cy: 4.619,
    r: 4.619,
    transform: "translate(275.248 -24.884)",
    fill: "#e0e1e3",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M215.561,278.872l23.807-12.384,25.474,5.906,25.213-21.049,25.6,16.143L340.6,282.065l25-28.026h25.76l25.113,18.355L439.113,243l26.471,1.758,25.639-15.028",
    transform: "translate(-210.942 -249.421)",
    fill: "none",
    stroke: "#e6e7e8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 4.619,
    cy: 4.619,
    r: 4.619,
    transform: "translate(87.565 229.595)",
    fill: "#72ae84"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 4.619,
    cy: 4.619,
    r: 4.619,
    transform: "translate(111.056 218.798)",
    fill: "#72ae84"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 4.619,
    cy: 4.619,
    r: 4.619,
    transform: "translate(136.347 227.435)",
    fill: "#72ae84"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 4.619,
    cy: 4.619,
    r: 4.619,
    transform: "translate(161.638 208.001)",
    fill: "#72ae84"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 4.619,
    cy: 4.619,
    r: 4.619,
    transform: "translate(186.929 223.116)",
    fill: "#72ae84"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    cx: 4.619,
    cy: 4.619,
    r: 4.619,
    transform: "translate(212.219 234.993)",
    fill: "#72ae84"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    cx: 4.619,
    cy: 4.619,
    r: 4.619,
    transform: "translate(237.51 208.001)",
    fill: "#72ae84"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 4.619,
    cy: 4.619,
    r: 4.619,
    transform: "translate(262.802 203.682)",
    fill: "#72ae84"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 4.619,
    cy: 4.619,
    r: 4.619,
    transform: "translate(288.092 224.196)",
    fill: "#72ae84"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    cx: 4.619,
    cy: 4.619,
    r: 4.619,
    transform: "translate(310.998 192.638)",
    fill: "#72ae84"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 4.619,
    cy: 4.619,
    r: 4.619,
    transform: "translate(337.405 197.204)",
    fill: "#72ae84"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    cx: 4.619,
    cy: 4.619,
    r: 4.619,
    transform: "translate(363.813 181.638)",
    fill: "#72ae84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M215.561,280.407l25.113-10.8,25.113,8.638L290.9,258.813l25.113,15.116,25.113,11.877,25.113-26.992,25.113-4.319,25.113,20.514,22.79-30.557,27.437,3.565,24.36-15.184",
    transform: "translate(-123.377 -46.194)",
    fill: "none",
    stroke: "#74ad85",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    id: "Total_Users",
    "data-name": "Total Users",
    transform: "translate(185.066 1910)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Total Users"))), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    id: "New_Users",
    "data-name": "New Users",
    transform: "translate(101.026 1910)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "New Users"))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_757",
    "data-name": "Path 757",
    d: "M4.281,0A4.281,4.281,0,1,1,0,4.281,4.281,4.281,0,0,1,4.281,0Z",
    transform: "translate(86.428 1901.938)",
    fill: "#72ae84"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 4.281,
    cy: 4.281,
    r: 4.281,
    transform: "translate(170.468 1901.938)",
    fill: "#e6e7e8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaGraph);
export default __webpack_public_path__ + "static/media/gaGraph.f4f84b7e.svg";
export { ForwardRef as ReactComponent };